






































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SubscriptionPackageItem } from "@/types/subscriptionPackage";
import { HttpService } from "@/services/api/httpService";
import axios, { AxiosError } from "axios";
import { ClientRedirectUri } from "@/types/client";

@Component
export default class DashboardClientRedirectUri extends Vue {
  httpService = new HttpService<ClientRedirectUri>();
  responseArray = new Array<ClientRedirectUri>();
  showModal: boolean = false;
  clientId: any = "";
  removeData = new ClientRedirectUri();
  async getList() {
    let httpService = new HttpService<Array<ClientRedirectUri>>();
    const response = await httpService.getList(
      `clients/${this.clientId}/redirect-uris`
    );
    this.responseArray = response.data;
    this.$emit("finishedLoading", true);
  }

  @Watch("$route", { immediate: true }) onRouteChanged() {
    this.clientId = this.$route.params.id;
    this.getList();
  }

  edit(redirectUri: ClientRedirectUri) {
    this.$router.push({
      name: "clientRedirectUriEdit",
      params: {
        id: this.clientId,
        redirectUriId: redirectUri.id
      }
    });
  }

  confirmRemove(data: ClientRedirectUri) {
    this.showModal = true;
    this.removeData = data;
  }
  async remove(data: ClientRedirectUri) {
    const response = await this.httpService.deleteItem(
      `clients/${data.clientId}/redirect-uris`,
      data.id
    );

    this.responseArray = this.responseArray.filter(
      (item: ClientRedirectUri) => item.clientId != data.clientId,
      this.$notification.success(`${data.redirectUri} successfully removed!`)
    );

    this.showModal = false;
    this.getList();
  }
}
